/*
 * Copyright (c) 2018 by Felix Heim, felix.heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.project-detail.crew', {
            parent: 'board.project-detail',
            url: '/crew',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER'],
                pageTitle: 'askApp.crew.home.title'
            },
            views: {
                'projectDetail@board.project-detail': {
                    templateUrl: 'app/board/project/detail/crew/crew.html',
                    controller: 'CrewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('crew');
                    $translatePartialLoader.addPart('enumProjectType');
                    return $translate.refresh();
                }],
                viewParams : [function() {
                    return {
                        type: 'crew'
                    };
                }]
            }
        })
        .state('board.project-detail.crew.edit-booking', {
            parent: 'board.project-detail.crew',
            url: '/{bookingId}/edit',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/project/detail/bookings/booking-dialog.html',
                    controller: 'ProjectDetailBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity2: ['ProjectDetailBooking', function(ProjectDetailBooking) {
                            return ProjectDetailBooking.get({id : $stateParams.bookingId}).$promise;
                        }],
                        entity: entity
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.crew', null, { reload: 'board.project-detail.crew' });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('booking');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.project-detail.nausys', {
            parent: 'board.project-detail.crew',
            url: '/nausys',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER'],
                pageTitle: 'askApp.crew.home.title'
            },
            views: {
                'projectDetail@board.project-detail': {
                    templateUrl: 'app/board/project/detail/crew/crew.html',
                    controller: 'CrewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('crew');
                    $translatePartialLoader.addPart('enumProjectType');
                    return $translate.refresh();
                }],
                viewParams : [function() {
                    return {
                        type: 'nausys'
                    };
                }]
            }
        })
        .state('board.project-detail.bm', {
            parent: 'board.project-detail.crew',
            url: '/bm',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER'],
                pageTitle: 'askApp.crew.home.title'
            },
            views: {
                'projectDetail@board.project-detail': {
                    templateUrl: 'app/board/project/detail/crew/crew.html',
                    controller: 'CrewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('crew');
                    $translatePartialLoader.addPart('enumProjectType');
                    return $translate.refresh();
                }],
                viewParams : [function() {
                    return {
                        type: 'bm'
                    };
                }]
            }
        })
    }
})();
